import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { RecurringPaymentInstruction } from '../../../../../../../models/submissions/recurring-payment-instruction';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';

@Component({
  selector: 'app-vb-payment-change-submission-multiple-payments',
  templateUrl: './vb-payment-change-submission-multiple-payments.component.html',
  styleUrls: ['../vb-payment-change-submission-recurring-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeSubmissionMultiplePaymentsComponent implements OnChanges {
  @Input({ required: true }) frequency!: VariableBenefitPaymentFrequencyEnum;

  @Input({ required: true }) activeRecurringPaymentInstruction!: RecurringPaymentInstruction;
  @Input({ required: true }) scheduledRecurringPaymentInstruction!: RecurringPaymentInstruction;

  public lastPaymentDateLabel: string = '';
  public lastPaymentAmountType: string = '';

  public startingPaymentDateLabel: string = '';
  public startingPaymentAmountType: string = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.activeRecurringPaymentInstruction ||
      changes.scheduledRecurringPaymentInstruction ||
      changes.frequency
    ) {
      switch (this.frequency) {
        case VariableBenefitPaymentFrequencyEnum.Monthly: {
          const lastPaymentDate = moment
            .utc(
              this.activeRecurringPaymentInstruction.endDate ??
                this.scheduledRecurringPaymentInstruction.paymentStartDate
            )
            .subtract(1, 'month');
          this.lastPaymentDateLabel = $localize`Last payment in ${lastPaymentDate.format('MMMM YYYY')}`;
          break;
        }
        case VariableBenefitPaymentFrequencyEnum.Annually:
          this.lastPaymentDateLabel = $localize`Last payment in ${moment
            .utc(this.scheduledRecurringPaymentInstruction.paymentStartDate)
            .clone()
            .subtract(1, 'year')
            .format('MMMM YYYY')}`;
          break;
      }

      this.lastPaymentAmountType = this.activeRecurringPaymentInstruction?.useMinimumAmount
        ? $localize`Minimum`
        : $localize`Custom`;

      this.startingPaymentDateLabel = $localize`Starting ${moment
        .utc(this.scheduledRecurringPaymentInstruction.paymentStartDate)
        .format('MMMM YYYY')}`;

      this.startingPaymentAmountType = this.scheduledRecurringPaymentInstruction?.useMinimumAmount
        ? $localize`Minimum`
        : $localize`Custom`;
    }
  }
}
